/**
 * IF11 MB4 Toll-Free Phone and Fax Number on the staff member forms.
 * Formats as the user types, as in Update Member Form (21) :2468-2473:
 * toll-free "1 (800) 555-0142" (a leading 1 is added), fax "(705) 288-6061".
 * The backend stores digits only.
 */
export const getMemberPhoneDigits = (value: string | null | undefined) => (value || "").replace(/\D/g, "");

export const formatStaffTollFreeInput = (value: string | null | undefined) => {
  let d = getMemberPhoneDigits(value);
  if (d && d[0] !== "1") d = `1${d}`;
  d = d.slice(0, 11);
  if (d.length <= 1) return d;
  if (d.length <= 4) return `${d[0]} (${d.slice(1)}`;
  if (d.length <= 7) return `${d[0]} (${d.slice(1, 4)}) ${d.slice(4)}`;
  return `${d[0]} (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
};

export const formatStaffFaxInput = (value: string | null | undefined) => {
  const d = getMemberPhoneDigits(value).slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const getMemberTollFreeFaxErrors = ({ tollFree, fax, ids }: {
  tollFree: string;
  fax: string;
  ids: { tollFree: string; fax: string };
}) => {
  const errors: Record<string, string> = {};
  const tollFreeDigits = getMemberPhoneDigits(tollFree);
  const faxDigits = getMemberPhoneDigits(fax);
  if (tollFreeDigits && tollFreeDigits.length !== 11) {
    errors[ids.tollFree] = "Enter the toll-free number with 11 digits, for example 1 (800) 555-0142, or leave it blank.";
  }
  if (faxDigits && faxDigits.length !== 10) {
    errors[ids.fax] = "Enter the fax number with 10 digits, for example (705) 288-6061, or leave it blank.";
  }
  return errors;
};
